import { Button, Col, List, Row } from 'antd';
import React, { useState } from 'react';
import {
  updateTrainerInfo,
  uploadTrainerImage,
} from '../../../services/trainerServices';
import CreationsEdit from './CreationsEdit';
import DeleteWarningModalWithAction from '../../Common/DeleteWarningModalWithAction';

function CreationCard(props) {
  const {
    item,
    index,
    trainer,
    updateTrainerLocalData,
    updateTrainerData,
  } = props;

  const [isCreationModalOpen, setIsCreationModalOpen] = useState(false);
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode.',
  });

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  function toggleCreationEdit() {
    setIsCreationModalOpen((prev) => !prev);
  }

  async function onSubmit(values) {
    const creations = trainer.creations;
    creations[index] = values;

    setStatus({ type: 'LOADING', message: 'Loading for request!' });
    let trainerData = {
      ...trainer,
      creations,
    };

    await updateTrainerData(trainerData)
      .then((response) => {
        updateTrainerLocalData(response.data.trainer);
        console.log('Updated Trainer: ', response);
        setStatus({ type: 'SUCCESS', message: 'Succesful response' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  const onDelete = async () => {
    trainer.creations.splice(index, 1);
    const creations = trainer.creations;
    const trainerData = { ...trainer, ...{ creations } };
    await updateTrainerData(trainerData)
      .then((response) => {
        updateTrainerLocalData(response.data.trainer);
        setStatus({ type: 'SUCCESS', message: 'Successfully deleted field' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <div>
      <List.Item key={item.title}>
        <List.Item.Meta
          title={
            <Row justify="space-between">
              {item.title}
              <Col>
                <Button
                  onClick={toggleCreationEdit}
                  style={{ marginRight: '8px' }}
                >
                  Edit
                </Button>
                <Button onClick={() => setIsDeleteModalVisible(true)}>
                  Delete
                </Button>
              </Col>
            </Row>
          }
          description={
            <>
              <strong>{item.widget.type.toUpperCase()} :</strong>&nbsp;
              <a href={item.widget.link}> {item.widget.link}</a>
            </>
          }
        />
        {item.description}
      </List.Item>
      <CreationsEdit
        initialValues={item}
        isOpen={isCreationModalOpen}
        status={status}
        toggle={toggleCreationEdit}
        onSubmit={onSubmit}
      />
      <DeleteWarningModalWithAction
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        action={onDelete}
      />
    </div>
  );
}

export default CreationCard;
